export interface OperationResultProps<T = void> {
  success: boolean;
  error?: string;

  result?: T;
}

export class OperationResult<T = void> implements OperationResultProps<T> {
  success: boolean;
  error?: string;

  result?: T;

  private constructor(success: boolean, error?: string, result?: T) {
    this.success = success;
    this.error = error;

    this.result = result;
  }

  static success<T>(result?: T) {
    return new OperationResult<T>(true, undefined, result);
  }

  static error<T = void>(error: string) {
    return new OperationResult<T>(false, error);
  }
}
